"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlignmentEntry = exports.AsrRecognizedPhone = exports.PhoneRecognition = exports.Timing = exports.WordRecognition = exports.Score = exports.Confidence = exports.ExerciseResult = void 0;
class ExerciseResult {
}
exports.ExerciseResult = ExerciseResult;
class Confidence {
}
exports.Confidence = Confidence;
class Score {
}
exports.Score = Score;
class WordRecognition {
}
exports.WordRecognition = WordRecognition;
class Timing {
}
exports.Timing = Timing;
class PhoneRecognition {
}
exports.PhoneRecognition = PhoneRecognition;
class AsrRecognizedPhone {
}
exports.AsrRecognizedPhone = AsrRecognizedPhone;
class AlignmentEntry {
}
exports.AlignmentEntry = AlignmentEntry;
//# sourceMappingURL=exercise-result.js.map